import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getUserSessionTokens } from "../utils/authHelper";
import { getLaravelApiToken, handleSignOut } from "../utils/apiHelpers";
import { ThemeProvider } from "@aws-amplify/ui-react";

import Dashboard from "../pages/Dashboard";
import FAQ from "../pages/FAQ";
import MonitorPage from "../pages/MonitorPage";
import SearchPage from "../pages/SearchPage";
import Profile from "../pages/Profile";
import Header from "./Header"; // Add this import
import Footer from "./Footer";

function AuthWrapper() {
  const [laravelApiToken, setLaravelApiToken] = useState(null);
  const [loadingToken, setLoadingToken] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (user) {
      const fetchTokens = async () => {
        try {
          const sessionTokens = await getUserSessionTokens();
          if (sessionTokens && sessionTokens.idToken) {
            const token = await getLaravelApiToken(sessionTokens.idToken);
            setLaravelApiToken(token);
          }
        } catch (err) {
          console.error("Error fetching session tokens:", err);
        } finally {
          setLoadingToken(false);
        }
      };
      fetchTokens();
    }
  }, [user]);

  const theme = {
    name: "custom-theme",
    tokens: {
      colors: {
        brand: {
          primary: {
            10: "#63c2e6",
            80: "#4faed0", // Slightly darker shade for hover effect
            100: "#63c2e6",
          },
        },
      },
      components: {
        button: {
          primary: {
            backgroundColor: { value: "{colors.brand.primary.100}" },
            _hover: {
              backgroundColor: { value: "{colors.brand.primary.80}" },
            },
          },
        },
        authenticator: {
          container: {
            borderRadius: "2rem",
            boxShadow: "0 10px 25px rgba(161, 161, 161, 0.3)",
          },
          // Add styles for form fields
          form: {
            borderRadius: "1rem",
            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
          },
        },
      },
    },
  };

  const handleSignOutWrapper = async (signOut) => {
    try {
      // Attempt to sign out on the server
      await handleSignOut(signOut, laravelApiToken);
    } catch (error) {
      console.error("Error during sign out:", error);
      // Continue with local sign out even if server request fails
    } finally {
      // Always perform these actions, regardless of server response
      setLaravelApiToken(null);
      setUser(null);
      // Call the Amplify signOut function to clear local auth state
      await signOut();
    }
  };

  return (
    <div className="auth-wrapper">
      <ThemeProvider theme={theme}>
        <Authenticator
          className="authenticator-body"
          loginMechanisms={["email"]}
          components={{
            Header: () => (
              <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                <img src="/logo.png" alt="logo" style={{ maxWidth: "250px" }} />
              </div>
            ),
          }}
          formFields={{
            signIn: {
              username: {
                label: "Email",
                placeholder: "Enter your email",
              },
            },
            signUp: {
              email: {
                label: "Email Address",
                placeholder: "Enter your email",
                isRequired: true,
              },
              password: {
                label: "Password",
                placeholder: "Enter your password",
                isRequired: true,
              },
              name: {
                label: "Full Name",
                placeholder: "Enter your full name",
                isRequired: true,
              },
              phone_number: {
                label: "Phone Number",
                placeholder: "Enter your phone number",
                isRequired: true,
              },
            },
          }}
        >
          {({ signOut, user: authUser }) => {
            setUser(authUser);
            return (
              <>
                <Header
                  user={authUser}
                  handleSignOut={() => handleSignOutWrapper(signOut)}
                />
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                  <Route
                    path="/dashboard"
                    element={
                      <Dashboard
                        user={authUser}
                        laravelApiToken={laravelApiToken}
                        loadingToken={loadingToken}
                        handleSignOut={() => handleSignOutWrapper(signOut)}
                      />
                    }
                  />
                  <Route path="/faq" element={<FAQ />} />
                  <Route
                    path="/monitor"
                    element={
                      <MonitorPage
                        user={authUser}
                        laravelApiToken={laravelApiToken}
                      />
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <Profile
                        user={authUser}
                        laravelApiToken={laravelApiToken}
                      />
                    }
                  />
                  <Route path="/search" element={<SearchPage />} />
                </Routes>
                <Footer />
              </>
            );
          }}
        </Authenticator>
      </ThemeProvider>
    </div>
  );
}

export default AuthWrapper;
